module.exports = __webpack_public_path__ + "static/media/coolblue.2c93ecba.png";